<template>
  <div id="password-reset">
    <section class="section">
      <h1 class="pagetitle">パスワード再設定</h1>
      <div class="columns is-flex-direction-column">
        <div class="column">
          <b-field label="現在のパスワード" class="password-field">
            <b-input
              ref="password"
              type="password"
              v-model="password"
              required
              password-reveal
            />
          </b-field>
          <b-field
            label="新しいパスワード"
            :type="!password || newPassword !== password ? '' : 'is-danger'"
            :message="!password || newPassword !== password ? '' : '新しいパスワードに更新してください'"
          >
            <b-input
              ref="newPassword"
              type="password"
              v-model="newPassword"
              required
              minlength="8"
              maxlength="100"
              :pattern="passwordRegEx"
              validation-message="半角英数字をそれぞれ1種類以上含む8文字以上100文字以下のパスワードにしてください"
              password-reveal
            />
          </b-field>
          <b-field
            label="新しいパスワード（確認）"
            :type="newPassword === newPasswordConfirm ? '' : 'is-danger'"
            :message="
              newPassword === newPasswordConfirm
                ? ''
                : 'パスワードの確認ができていない'
            "
          >
            <b-input
              ref="newPasswordConfirm"
              type="password"
              v-model="newPasswordConfirm"
              required
              password-reveal
            />
          </b-field>

          <div class="formbutton">
            <b-button
              class="elkatsubutton--base"
              @click="submit"
              :disabled="disabled"
              :loading="sending"
            >
              パスワードを再設定する
            </b-button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import * as authServices from '@/services/authServices';

export default {
  name: 'ProfilePasswordReset',
  computed: {
    disabled() {
      if (this.password || this.newPassword || this.newPasswordConfirm) {
        return !(
          this.password != '' &&
          this.newPassword != '' &&
          this.newPasswordConfirm != '' &&
          this.$refs.password.isValid &&
          this.$refs.newPassword.isValid &&
          this.$refs.newPasswordConfirm.isValid &&
          this.newPassword == this.newPasswordConfirm
        );
      }

      return true;
    }
  },
  data() {
    return {
      passwordRegEx: '(?=.*?[a-zA-Z])(?=.*?\\d)[a-zA-Z\\d]{8,100}',
      password: '',
      newPassword: '',
      newPasswordConfirm: '',
      sending: false
    };
  },
  methods: {
    async submit() {
      this.sending = true;
      try {
        await authServices.resetPassoword(this.password, this.newPassword);
        this.$buefy.toast.open({
          duration: 3000,
          message: 'パスワードを変更しました。',
          type: 'is-success'
        });
      } catch (err) {
        let errorMessage = err.message;
        if (err.code == "auth/wrong-password") {
          errorMessage = "現在のパスワードと異なります。"
        }
        this.$buefy.toast.open({
          duration: 3000,
          message: errorMessage,
          type: 'is-danger'
        });
      } finally {
        this.sending = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import '../assets/scss/profile-password-reset.scss';
.password-field {
  height: 100px;
}
</style>
